const TOKEN_KEY = 'mindnet.token'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}
export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t)
  else localStorage.removeItem(TOKEN_KEY)
}

async function request(path, opts = {}) {
  const headers = { 'Content-Type': 'application/json', ...(opts.headers || {}) }
  const token = getToken()
  if (token) headers['Authorization'] = `Bearer ${token}`
  const res = await fetch(`/api${path}`, { ...opts, headers })
  if (!res.ok) {
    let body
    try { body = await res.json() } catch { body = { error: res.statusText } }
    const err = new Error(body.error || `HTTP ${res.status}`)
    err.status = res.status
    err.body = body
    throw err
  }
  if (res.status === 204) return null
  return res.json()
}

export const api = {
  health: () => request('/health'),
  login: (email, password) => request('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  logout: () => request('/auth/logout', { method: 'POST' }),
  me: () => request('/auth/me'),

  checkInvite: (token) => request(`/auth/invite/${encodeURIComponent(token)}`),
  acceptInvite: (token, password) => request(`/auth/invite/${encodeURIComponent(token)}/accept`, {
    method: 'POST', body: JSON.stringify({ password }),
  }),

  listUsers: () => request('/users'),
  createUser: (data) => request('/users', { method: 'POST', body: JSON.stringify(data) }),
  updateUser: (id, data) => request(`/users/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  blockUser: (id) => request(`/users/${id}/block`, { method: 'POST' }),
  unblockUser: (id) => request(`/users/${id}/unblock`, { method: 'POST' }),
  setUserRole: (id, role) => request(`/users/${id}/role`, { method: 'POST', body: JSON.stringify({ role }) }),
  deleteUser: (id) => request(`/users/${id}`, { method: 'DELETE' }),
  generateInvite: (id) => request(`/users/${id}/invite`, { method: 'POST' }),

  listSurveys: () => request('/surveys'),

  createAccess: (data) => request('/access', { method: 'POST', body: JSON.stringify(data) }),
  deleteAccess: (id) => request(`/access/${id}`, { method: 'DELETE' }),
  lockAccess: (id) => request(`/access/${id}/lock`, { method: 'POST' }),
  unlockAccess: (id) => request(`/access/${id}/unlock`, { method: 'POST' }),
  updateAccess: (id, data) => request(`/access/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),

  myResponses: () => request('/responses/mine'),
  getResponse: (accessId) => request(`/responses/${accessId}`),
  saveResponse: (accessId, data) => request(`/responses/${accessId}/save`, { method: 'POST', body: JSON.stringify(data) }),
  finishResponse: (accessId, data) => request(`/responses/${accessId}/finish`, { method: 'POST', body: JSON.stringify(data) }),
}
